import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';

class FixedAsset extends React.Component {
   render() {
      return (
         <div className="FixedAsset" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/fixedAsset/" activeStyle={{ color: 'red' }} >FixedAsset</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/fixedAsset/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/fixedAsset/new" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
                  <li>
                     <Link to="/fixedAsset/allFixedAssets" activeStyle={{ color: 'red' }} >Show All Fixed Assets</Link>
                  </li>
                  <li>
                     <Link to="/fixedAsset/dueBills" activeStyle={{ color: 'red' }} >Due Bills</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

FixedAsset.propTypes = {
   children: PropTypes.object
};

export default FixedAsset;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/FixedAsset.js
 **/